
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.084 -24014.699 13.799 14.4"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_163_1","data-name":"Symbol 163 – 1","transform":"translate(-19907.385 -25504)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_7737","data-name":"Group 7737","transform":"translate(129 1041)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3408","d":"M12.718 7.04V4.213a1.486 1.486 0 0 0-.83-1.337A11.46 11.46 0 0 0 7.348 2a11.021 11.021 0 0 0-4.518.9A1.452 1.452 0 0 0 2 4.213V12.6a1.486 1.486 0 0 0 .83 1.337 10.941 10.941 0 0 0 4.518.9l1.126-.047","data-name":"Path 3408","transform":"translate(886 447)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3409","d":"M2 33.7a9.835 9.835 0 0 0 5.348 1.36l.823-.028.738-.073","data-name":"Path 3409","transform":"translate(886 422.607)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3410","d":"M2 15.9a9.835 9.835 0 0 0 5.348 1.36A9.778 9.778 0 0 0 12.7 15.9","data-name":"Path 3410","transform":"translate(886 436.304)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3411","d":"M47.623 40.932L47.6 35.7l1.89 1.821","data-name":"Path 3411","transform":"translate(850.911 421.068)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1648","d":"M1.844 0L0 1.821","data-name":"Line 1648","transform":"translate(896.667 456.768)"}})])])])
          )
        }
      }
    